import type {AppThunk} from '../../../../actions/types'
import {getBuildsArg} from '../../../../rest/builds'
import type {LoadedEndpoints} from '../../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../../routes/loadEndpoint'
import {restApi} from '../../../../services/rest'
import type {BuildId} from '../../../../types'

import {getDependantsLocator} from './BuildPartOf.utils'

export const preloadBuildPartOf =
  (buildId: BuildId): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const locator = getDependantsLocator(buildId)
    return [
      dispatch(
        loadEndpoint(
          restApi.endpoints.getAllBuildsNormalized,
          getBuildsArg(locator, {
            withRunningInfo: true,
            withQueuedInfo: true,
            withBuildTypeDetails: true,
          }),
        ),
      ),
      dispatch(
        loadEndpoint(
          restApi.endpoints.getAllBuildsNormalized,
          getBuildsArg(locator, {
            withShortBuildDetails: true,
            withPipelineRuns: true,
            withAnchorBuild: true,
          }),
        ),
      ),
    ]
  }
